import { SelectWidget } from 'angular2-schema-form';
import { Component } from '@angular/core';
import { Http } from '@angular/http';
import { LoopBackConfig } from './../../sdk/lb.config';
// import { OnInit } from '@angular/core';

@Component({
  selector: 'app-sf-select-widget',
  templateUrl: './select.widget.html'
})
export class MySelectWidgetComponent extends SelectWidget { // implements OnInit {
  public data: any = [];
  private baseUrl = '';
  private load = true;

  constructor(
    private http: Http
  ) {
    super();
    this.baseUrl = `${LoopBackConfig.getPath()}/${LoopBackConfig.getApiVersion()}`;
  }

  // ngOnInit() {
  //   if (this.schema.datasource === 'remote') {
  //     console.log('remote');
  //     this.http.get(`${this.baseUrl}/${this.schema.model}`)
  //       .map((res: any) => res.json())
  //       .subscribe(result => {
  //         this.data = result;
  //       });
  //   }
  // }

  readControl(schema, control) {
    if (schema.widget.id === 'sf-select') {
      // console.log('schema.datasource:', schema.datasource);
      if (schema.datasource === 'local') {
        if (!(this.data.length > 0) && this.load && schema.data !== '') {
          this.data = schema.data;
          this.load = false;
          console.log(schema.data);
          console.log(this.data);
          return true;
        } else {
          return true;
          // return false;
        }
      } else if (schema.datasource === 'remote') {

        // console.log('this.data.length > 0:', (!(this.data.length > 0)));
        // console.log('this.load:', this.load);
        if (!(this.data.length > 0) && this.load && control.value !== '') {
          const url = this.baseUrl + control.value;
          this.load = false;
          // console.log('remote', url);
          // console.log('this.data.length > 0:', (!(this.data.length > 0)));
          this.http.get(url)
            .map((res: any) => res.json())
            .subscribe(result => {
              let i = 0;
              for (const b of result) {
                // console.log('DATA b:', b);
                this.data[i++] = {
                  'value': b.name,
                  'description': b.name
                };
              }
              console.log(this.data);
              return true;
            });
        } else {
          return true;
          // return false;
        }
      }
    } else {
      return true;
      // return false;
    }
  }
}



// WEBPACK FOOTER //
// ./src/shared/form-widgets/select/select.widget.ts